/**
 * Create function for generating HTML element IDs (with shared component prefix)
 *
 * NOTE: Will convert provided suffixes to kebab-case for ID/attribute safety
 *
 * @param prefix - Prefix for all generated element IDs
 *
 * @example
 * const getElId = createGetElId("the-app-confirm-dialog");
 * const elementId = getElId('actions-confirm-btn');
 *
 * @example
 * const getElId = createGetElId("some-list-item");
 * const elementId = getElId('actions-delete-btn', item.id);
 */
export const createGetElId =
  (prefix: string) =>
  (...suffixes: (string | number)[]) =>
    `${prefix}-${suffixes.map((suffix) => getSafeElId(suffix)).join("-")}`;

const getSafeElId = (id: string | number) => {
  return (
    id
      .toString()
      .toLowerCase()
      // Replace spaces with '-'
      .replace(/\s+/g, "-")
      // Remove non-alphanumeric and underscore chars
      .replace(/[^a-z0-9_-]+/g, "")
      // Replace multiple '-' with single '-'
      .replace(/-+/g, "-")
      // Trim leading/trailing '-'
      .replace(/^-+|-+$/g, "")
  );
};
